import { render, staticRenderFns } from "./PremiumCard.htm?vue&type=template&id=68a85465&scoped=true&"
import script from "./PremiumCard.ts?vue&type=script&lang=js&"
export * from "./PremiumCard.ts?vue&type=script&lang=js&"
import style0 from "./PremiumCard.scss?vue&type=style&index=0&id=68a85465&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a85465",
  null
  
)

export default component.exports